export default {
  metadata: {
    version: '1.0.0',
    id: 'avatar_segmented_ring-1.0.0',
    name: 'JDSAvatarV2SegmentedRing'
  },
  hierarchy: {
    container: [
      {
        'ring-container': ['jds_segmented_ring_item']
      },
      'jds_avatar_v2_default'
    ]
  },
  base: {
    container: {
      'flex-direction': '{flexDirection.stack}',
      'justify-content': '{justifyContent.center}',
      'align-items': '{alignItems.center}',
      opacity: '{opacity.enabled}',
      hidden: false
    },
    'ring-container': {
      hidden: false,
      'flex-direction': '{flexDirection.stack}',
      'justify-content': '{justifyContent.center}',
      'align-items': '{alignItems.center}',
      'z-index': 1,
      disabled: true
    },
    jds_segmented_ring_item: {
      size: 'medium',
      'z-index': 1
    },
    jds_avatar_v2_default: {
      size: 'medium'
    }
  },
  variant: {
    size: {
      'xtra-xtra-large': {
        jds_avatar_v2_default: {
          size: 'xtra-xtra-large'
        },
        jds_segmented_ring_item: {
          size: 'xtra-xtra-large'
        }
      },
      'xtra-large': {
        jds_avatar_v2_default: {
          size: 'xtra-large'
        },
        jds_segmented_ring_item: {
          size: 'xtra-large'
        }
      },
      large: {
        jds_avatar_v2_default: {
          size: 'large'
        },
        jds_segmented_ring_item: {
          size: 'large'
        }
      },
      small: {
        jds_avatar_v2_default: {
          size: 'small'
        },
        jds_segmented_ring_item: {
          size: 'small'
        }
      },
      'xtra-small': {
        jds_avatar_v2_default: {
          size: 'xtra-small'
        },
        jds_segmented_ring_item: {
          size: 'xtra-small'
        }
      }
    },
    disabled: {
      true: {
        container: {
          disabled: true,
          opacity: '{opacity.disabled}'
        }
      }
    }
  },
  combination: [{}],
  combination_config: [[]],
  api: {
    config: {
      size: {
        values: [
          'medium',
          'xtra-xtra-large',
          'xtra-large',
          'large',
          'small',
          'xtra-small'
        ]
      },
      disabled: {
        values: [false, true]
      }
    },
    data: {
      container: {
        '_ring.startAngle': {
          type: 'string',
          name: 'startAngle'
        },
        '_ring.endAngle': {
          type: 'string',
          name: 'endAngle'
        }
      },
      jds_avatar_v2_default: {
        image: {
          type: 'image',
          name: 'avatarImage'
        },
        initials: {
          type: 'string',
          name: 'avatarInitials'
        },
        kind: {
          type: 'JDSAvatarV2Default.kind',
          name: 'avatarKind'
        }
      },
      'ring-container': {
        value: {
          type: 'list',
          name: '_ring',
          object: {
            startAngle: 'number',
            endAngle: 'number'
          }
        },
        length: {
          type: 'number',
          name: 'count',
          doc_description: 'It can be used to control count of segments.'
        }
      },
      jds_segmented_ring_item: {
        startAngle: {
          type: 'string',
          name: 'ring.startAngle'
        },
        endAngle: {
          type: 'string',
          name: 'ring.endAngle'
        }
      }
    },
    a11y: {
      container: {
        properties: {
          'aria-label': {
            name: 'ariaLabel',
            value: 'Avatar with Activity Ring'
          },
          'aria-describedby': {
            name: 'ariaDescribedby',
            platform: 'web,ios'
          }
        }
      }
    }
  }
};
